export enum ClientType {
  RETAIL = 'RETAIL',
  PROFESSIONAL = 'PROFESSIONAL',
  ELIGIBLE_COUNTERPARTY = 'ELIGIBLE_COUNTERPARTY',
  INSTITUTIONAL = 'INSTITUTIONAL',
}

export enum KnowledgeAndExperience {
  BASIC = 'BASIC',
  INFORMED = 'INFORMED',
  ADVANCED = 'ADVANCED',
}

export const KNOWLEDGE_AND_EXPERIENCE_OPTIONS = [
 { id: KnowledgeAndExperience.BASIC, displayValue: 'Basic' },
  { id: KnowledgeAndExperience.INFORMED, displayValue: 'Informed' },
  { id: KnowledgeAndExperience.ADVANCED, displayValue: 'Advanced' },
];

export const CLIENT_TYPE = [
  { id: ClientType.RETAIL, displayValue: 'Retail' },
  { id: ClientType.PROFESSIONAL, displayValue: 'Professional' },
  { id: ClientType.ELIGIBLE_COUNTERPARTY, displayValue: 'Eligible Counterparty' },
  { id: ClientType.INSTITUTIONAL, displayValue: 'Institutional' },
];

// TODO: Checking with Selina if this has to be changed
export const CLIENT_TYPE_MAP = {
  RETAIL_BASIC_INVESTOR: 'Retail - Basic Investor',
  RETAIL_INFORMED_INVESTOR: 'Retail - Informed Investor',
  RETAIL_ADVANCED_INVESTOR: 'Retail - Advanced Investor',
  INSTITUTIONAL: 'Institutional',
};